const TOASTER_LIMIT = 2;
const featureToggleAllowedUserRoles = [

  8893,

  11129,

  19138,

  10791,

  15637,

  11147,

  7720,

  8840,

  15813,

  10789,

  16022,

  16248,

  19057,

  16322,

  16323,

  16619,

  7305,

  16981,

  15190,

  16969,

  15151,

  5235,

  17293,

  17370,

  19201,

  19055,

  19054,

  19059,

  16319,
  //Joe Jakubowski
  9967,

  19167,

  20032,

  20003,

  19904,

  19867,

  20035,

  19345,

  20304,

  20033,

  6209,
  // Chris Sauer - DELETE_LINE_IN_JENKIN
  6902,
  // Matt Wille - DELETE_LINE_IN_JENKIN
  15828,

  19463,

  19453,
  // Mary Dambly - DELETE_LINE_IN_JENKIN
  13964,

  14307,

  2037,

  15901,

  19421,

  10620,

  14139,

  15590,

  10834,

  19064,

  6210,

  19576,

  15016,

  13108,

  10951,

  12251,

  17369,

  19359,

  16067,

  19866,

  12352,

  19845,

  19885,

  19745,

  19626,

  1, 2, 3, 4, 6, 7, 8, 9,
];
const identityPlannerAllowedUserPrivileges = [
  "BetaUser",
  "IdentityHomepage",
  "IdentityPlanner",
];

const rolesForTiles = {
  showOnBoardingPortal: "AccessNewOnboardingPortal",
  rawdataattributebuilder: ["RawDataAttributeBuilder", "AkAdministrator"],
  showSftp: "AccessOnboardingSFTPTile",
  showtabsoption: ["IdentityHomepage"],
  showElementOne: "ElementOneAnalyst",
};

const onboardingFilesLimitPerPage = 25;
const rawDataAttributesListLimitPerPage = 25;
const audienceListLimitPerPage = 25;
const reportingFilesLimitPerPage = 25;
const datafeedMappingLimitPerPage = 50;
const termsConditionFalse = 2;
const termsConditionTrue = 3;

const emailTaxonomiesContent = {
  subject:
    "A new segment has been created via Neustar for syndication to your platform",
  message:
    "A new segment has been created via Neustar for syndication. This needs to be configured as soon as possible so that an audience can be delivered. When compete, please confirm the segment has been created.",
};

const identifierLabel = {
  COOKIE_BASED: "Browser",
  HASHED_PII: "Neustar Identity",
  MOBILE: "Mobile ID",
  SYNDICATION: "Syndication ID",
};

const destinationPlatformReachHoldTime = 30000;
export {
  TOASTER_LIMIT,
  featureToggleAllowedUserRoles,
  identityPlannerAllowedUserPrivileges,
  onboardingFilesLimitPerPage,
  emailTaxonomiesContent,
  rawDataAttributesListLimitPerPage,
  audienceListLimitPerPage,
  reportingFilesLimitPerPage,
  identifierLabel,
  datafeedMappingLimitPerPage,
  rolesForTiles,
  destinationPlatformReachHoldTime,
  termsConditionFalse,
  termsConditionTrue,
};
